export default {
  expirationSettings: 'Expiration settings',
  inactivityInterval: 'Inactivity interval',
  expirationInterval: 'Expiration interval',
  inactivityIntervalHelpText: 'Defines when the user is counted as inactive',
  expirationIntervalHelpText: 'Defines the inactivity time period after which the auth token is expired',
  selectTemplate: 'Select template',
};
